<div
    class="agpr-product-feature-item"
    [ngClass]="{'agpr-product-feature-item-noPermission': !hasPermission}"
    id="{{id}}"
>
    <div class="agpr-product-feature-item-header">
        <span class="{{headerIcon}} agpr-product-feature-item-headerIcon"></span>
        <div class="agpr-product-feature-item-headerText">{{header | localize}}</div>
    </div>
    @if (!hasPermission) {
        <span
            class="fa-solid fa-lock agpr-product-feature-item-header-noPermission"
            (click)="openTab(buttonUrl)"
        ></span>
    }
    <div class="agpr-product-feature-item-message">{{message | localize}}</div>
    <div class="agpr-product-feature-item-anchor">
        <agpr-button
            [id]="id"
            [label]="buttonTitle"
            [style]="hasPermission ? buttonTypes.primaryB : buttonTypes.primary"
            (click)="openTab(buttonUrl)"
        ></agpr-button>
        <span>
            <a
                class="agpr-product-feature-item-link"
                target="_blank"
                [href]="externalUrl"
                [attr.aria-describedby]="id + '_externalLink'"
            >
                {{ 'LandingPage.productFeatureItem.externalLinks.text' | localize }}
                <span [id]="id + '_externalLink'" class="u-srOnly">{{ 'Dashboard.sidebar.externalLink' | localize }}</span>
                <i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square agpr-product-feature-item-arrowIcon"></i>
            </a>
        </span>
    </div>
</div>
